import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import JSZip from "jszip"
import { Logger } from '@/js/utils/Logger.js';
// import { uploadBytes } from "firebase/storage";


// import { initializeApp } from 'firebase-admin/app';
// import config from 'config'

class FirebaseCommon{

    static async uploadFile( file, path ){
        const storageRef = firebase.storage().ref(path);
        Logger.info("FirebaseCommon uploadFile:" + path);
        await storageRef.put(file).then((snapshot) => {
            Logger.debug(snapshot);
            Logger.debug('Uploaded a blob or file!');
          }).catch((e)=>{
            console.log(e);
          });
        return await storageRef.getDownloadURL();
    }

    static async getImageUrl(fileName){
        return await new Promise(function (resolve) {
            try{
                firebase
                .storage()
                .ref()
                .child("AcryPro/" + firebase.auth().currentUser.uid + "/" + fileName)
                .getDownloadURL()
                .then(function (url) {
                  resolve(url);
                }).catch((e)=>{
                    console.log(e)
                    resolve("")
                })
            } catch(e){
                console.log(e)
                resolve("")
            }
          }.bind(this));
    }

    static async downloadDesignZip( designId ){
        let url = await firebase.storage().ref().child(FirebaseCommon.getBaseFilePath() + FirebaseCommon.getZipFileName(designId)).getDownloadURL();
        let info = {};
        info.zipData = await this.downloadZip(url);
        console.log(info.zipData);
        let str = await info.zipData.file(designId + "/product.json").async('string');
        info.productJson = JSON.parse(str);
        return info;
    }

    static async downloadZip(url){
        Logger.info("download image :" + url);
        const withoutQuery = url.split("?")[0];
        const decoded = decodeURIComponent(withoutQuery);
        const filename = decoded.split("/").pop();
        return new Promise((resolve) => {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = () => {
              var blob = xhr.response;
              const file = new File([blob], filename, {});
              JSZip.loadAsync(file).then((res) => {
                resolve(res);
              });
            };
            xhr.open('GET', url);
            xhr.send();
        });
    }

    static async downloadPngImage(url){
        Logger.info("download image :" + url);
        const withoutQuery = url.split("?")[0];
        const decoded = decodeURIComponent(withoutQuery);
        const filename = decoded.split("/").pop();
        return new Promise((resolve) => {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = () => {
              const blob = new Blob([xhr.response], { type: "image/png" });
              const file = new File([blob], filename, {});
              resolve(file);
            };
            xhr.open('GET', url);
            xhr.send();
        });
    }

    static async downloadSvgImage(url){
        Logger.info("download image :" + url);
        const withoutQuery = url.split("?")[0];
        const decoded = decodeURIComponent(withoutQuery);
        const filename = decoded.split("/").pop();
        return new Promise((resolve) => {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'arraybuffer';
            xhr.onload = () => {
                const blob = new Blob([xhr.response], { type: "image/svg+xml" });
                const file = new File([blob], filename, { type: "image/svg+xml" });
                resolve(file);
            };
            xhr.open('GET', url);
            xhr.send();
        });
    }

    static dummyMonoImage = { "S":"", "M":"", "L":"" };
    // AcryPrint用のダミーのmono画像のURLを返す
    static async getDummyMonoImage( size ){
        if( this.dummyMonoImage[size] ) return this.dummyMonoImage[size];
        const filePaths = {
            "S":"AcryPro/DummyImage/acryprint_dummy_mono_s.png",
            "M":"AcryPro/DummyImage/acryprint_dummy_mono_m.png",
            "L":"AcryPro/DummyImage/acryprint_dummy_mono_l.png"
        };

        const url = await new Promise(function (resolve) {
            try{
                firebase
                .storage()
                .ref()
                .child(filePaths[size])
                .getDownloadURL()
                .then(function (url) {
                  resolve(url);
                }).catch((e)=>{
                    console.log(e)
                    resolve("")
                })
            } catch(e){
                console.log(e)
                resolve("")
            }
          }.bind(this));

        return this.dummyMonoImage[size] = url;
    }

    // =========================== //
    //       ファイル名関連
    // =========================== //
    static getBehalfCreateBaseFilePath(){
        return "AcryPro/BehalfCreateData/" + firebase.auth().currentUser.uid + "/";
    }
    static getAcrylicTicketSettingBaseFilePath(){
        return "AcryPro/AcrylicTicketSetting/" + firebase.auth().currentUser.uid + "/";
    }
    static getBaseFilePath(){
        return "AcryPro/" + firebase.auth().currentUser.uid + "/";
    }
    static getZipFileName(productId){
        return productId + ".zip"
    }
    static getDesignFileName(productId){
        return productId + "_design" + ".png"
    }
    static getSvgCutlineFileName(productId){
        return productId + "_cutline" + ".svg"
    }
    static getPngCutlineFileName(productId){
        return productId + "_cutline" + ".png"
    }
    static getPreviewFileName(productId){
        return productId + "_preview" + ".png"
    }
    static getFrontFileName(productId, itemId){
        return productId + "_" + itemId + "_front" + ".png"
    }
    static getFrontMonoFileName(productId, itemId){
        return productId + "_" + itemId + "_front_mono" + ".png"
    }
    static getFrontPreviewFileName(productId, itemId){
        return productId + "_" + itemId + "_front_preview" + ".png"
    }

    static getHistoryFrontFileName(productId){
        return productId + "_" + 0 + "_front" + ".png"
    }

}
export { FirebaseCommon }
